import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { mediaActions } from '@app/store/media/actions/media.actions';
import { mediasActions } from '../actions/medias.actions';
import { selectLastParams } from '../selectors/medias.selector';

@Injectable()
export class MediaMediasBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    refreshOnMutation$ = createEffect(() => {
        return this.actions.pipe(
            ofType(mediaActions.createMediaSuccess, mediaActions.updateMediaSuccess, mediaActions.deleteMediaSuccess),
            concatLatestFrom(() => this.store.select(selectLastParams)),
            map(([, lastParams]) => mediasActions.getMedia({ value: lastParams })),
        );
    });
}
